export class PublishStateRegion{
    regionId:number;
    publishStateId:number;
}